import React, { useState, useRef, useEffect } from 'react';
import { Modal, Toast } from 'react-bootstrap';
import { Controller } from "react-hook-form";
import Select from 'react-select';
import TextareaAutosize from "react-textarea-autosize";

const AddCursoModal = ({
	showModalAddCurso,
	setShowModalAddCurso,
	setShowModalAddTopico,
	dataTopicos,
	setIdTopico,
	idTopico,
	customStyles,
	cursoAddFile,
	setCursoAddFile,
	uploadCursoProgress,
	register,
	errors,
	control,
	handleSubmit,
	onSubmitAddCurso
}) => {
	const [toast, setToast] = useState({});
	const [showToast, setShowToast] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [showScrollTop, setShowScrollTop] = useState(false);
	const [showScrollBottom, setShowScrollBottom] = useState(false);
	const modalBodyRef = useRef(null);

	// Função para mostrar mensagens de toast
	const showToastMessage = (header, body, variant = 'error') => {
		const type = variant === 'success' ? 'toast-success' : variant === 'danger' ? 'toast-error' : 'toast-' + variant;
		setToast({ header, body, type });
		setShowToast(true);
	};

	// Detectar scroll e atualizar indicadores visuais
	useEffect(() => {
		const checkScroll = () => {
			if (modalBodyRef.current) {
				const { scrollTop, scrollHeight, clientHeight } = modalBodyRef.current;
				setShowScrollTop(scrollTop > 10);
				setShowScrollBottom(scrollTop + clientHeight < scrollHeight - 10);
			}
		};

		const modalBodyElement = modalBodyRef.current;

		if (showModalAddCurso && modalBodyElement) {
			checkScroll();
			modalBodyElement.addEventListener('scroll', checkScroll);
			const timeoutId = setTimeout(checkScroll, 100);

			return () => {
				modalBodyElement.removeEventListener('scroll', checkScroll);
				clearTimeout(timeoutId);
			};
		} else {
			// Resetar indicadores quando modal fecha
			setShowScrollTop(false);
			setShowScrollBottom(false);
		}
	}, [showModalAddCurso]);

	// Função para submeter o formulário com feedback de toast
	const handleSubmitWithToast = async (data) => {
		setIsLoading(true);
		try {
			const result = await onSubmitAddCurso(data);

			if (result && result.success) {
				showToastMessage('Sucesso!', result.message || 'Curso adicionado com sucesso.', 'success');
				setTimeout(() => {
					setShowModalAddCurso(false);
					setIdTopico("");
				}, 2000);
			} else if (result) {
				showToastMessage('Erro!', result.message || 'Erro ao adicionar curso.', 'danger');
			}
		} catch (error) {
			showToastMessage('Erro!', error.message || 'Ocorreu um erro inesperado.', 'danger');
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
            <Toast
                show={showToast}
                onClose={() => setShowToast(false)}
                delay={4000}
                autohide
                className={`position-fixed top-0 end-0 m-3 toast-icon ${toast.type || 'toast-error'}`}
                style={{ zIndex: 1060 }}
            >
                <Toast.Header>
                    <strong className="me-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

			<Modal
				size="lg"
				show={showModalAddCurso}
				onHide={() => {
					setShowModalAddCurso(false);
					setIdTopico("");
				}}
				backdrop="static"
				className="modal-adicionar-curso"
			>
				<form onSubmit={handleSubmit(handleSubmitWithToast)}>
					<Modal.Header closeButton>
						<span className="fw-semibold fs-5 text-primary">Adicionar Curso</span>
					</Modal.Header>
					<Modal.Body 
						ref={modalBodyRef}
						className="bg-gray-100 modal-adicionar-curso-body"
					>
						{showScrollTop && (
							<div className="scroll-indicator scroll-indicator-top">
								<i className="bi bi-chevron-up"></i>
							</div>
						)}
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="body">
										<div className="d-flex">
											<div className="d-flex flex-column w-100">
												<div className="row">

													<div className="col-12 col-md-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Nome</label>
															<input
																type="text"
																{...register('nome', { required: true })}
																placeholder="Nome do curso"
																className="form-control border-new-light"
															/>
															{errors.nome && <span className='text-danger fs-7'>Nome do curso é obrigatório.</span>}
														</div>
													</div>

													<div className="col-12 col-md-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Descrição</label>
															<input
																type="text"
																{...register('descricao')}
																placeholder="Breve descrição do curso"
																className="form-control border-new-light"
															/>
														</div>
													</div>

													<div className="col-9 col-md-10">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Tema</label>
															<Controller
																name="idTopico"
																control={control}
																defaultValue={[]}
																rules={{ required: true }}
																render={({ field }) => (
																	<Select
																		{...field}
																		options={dataTopicos.map((value) => ({
																			value: value.id,
																			label: `${value.nome}`,
																		}))}
																		value={field.value}
																		styles={customStyles}
																		rules={{ required: true }}
																		onChange={value => {
																			field.onChange(value)
																			if (value && value.value) {
																				setIdTopico(value.value)
																			}
																		}}
																		placeholder="Selecione o tema"
																		noOptionsMessage={() => "Nenhum tema encontrado."}
																	/>
																)}
															/>
															{errors.idTopico && <span className='text-danger fs-7'>Selecione um tema.</span>}
														</div>
													</div>

													<div className="col-3 col-md-2">
														<div className="d-flex flex-column h-100">
															<label className="form-label opacity-0">button</label>
															<span
																className="btn btn-outline-primary btn-height-51px mb-3 d-flex align-items-center justify-content-center"
																onClick={() => {
																	setShowModalAddTopico(true);
																	setShowModalAddCurso(false);
																}}
															>
																<i className="bi bi-plus"></i>
															</span>
														</div>
													</div>

													<div className="col-12 col-md-4">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Thumbnail</label>
															<label
																htmlFor="thumbnail"
																className={`form-control label-input ${cursoAddFile ? 'border-success bg-success' : 'border-primary bg-primary'} text-white fw-medium text-center`}
															>
																<i className="bi bi-card-image me-2"></i> Enviar Imagem
															</label>
															<Controller
																control={control}
																name="thumbnail"
																rules={{ required: true }}
																render={({ field: { onChange, onBlur, value, ref } }) => (
																	<input
																		id='thumbnail'
																		type="file"
																		onBlur={onBlur}
																		ref={ref}
																		onChange={(e) => {
																			const files = e.target.files;
																			onChange(files);
																			if (files && files.length > 0) {
																				setCursoAddFile(true);
																			} else {
																				setCursoAddFile(false);
																			}
																		}}
																	/>
																)}
															/>
															{errors.thumbnail && <span className='text-danger fs-7'>Imagem do curso é obrigatório.</span>}
														</div>
													</div>

													<div className="col-12 col-md-8">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Prazo de Validade <span className="text-dark">(em meses)</span></label>
															<input
																type="number"
																{...register("prazo_validade", { required: true })}
																placeholder="Ex: 12"
																className="form-control border-new-light"
															/>
															{errors.prazo_validade && <span className='text-danger fs-7'>Prazo de Validade é obrigatório.</span>}
														</div>
													</div>

													<div className="col-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Resumo</label>
															<TextareaAutosize
																{...register('resumo')}
																placeholder="Informações gerais sobre o curso"
																className="form-control border-new-light"
															/>
														</div>
													</div>

													<div className="col-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Objetivo</label>
															<TextareaAutosize
																{...register('objetivo')}
																placeholder="Objetivos do curso"
																className="form-control border-new-light"
															/>
														</div>
													</div>

													<div className="col-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Conteúdo Programático</label>
															<TextareaAutosize
																{...register('conteudo_programatico')}
																placeholder="Conteúdo programático do curso"
																className="form-control border-new-light"
															/>
														</div>
													</div>

													<div className="col-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Disponibilidade do curso</label>
															<div className="row g-3">
																<div className="col-md-6">
																	<label className="form-label">Data inicial</label>
																	<input
																		type="date"
																		{...register('dataInicio')}
																		className="form-control border-new-light w-100"
																		style={{ minWidth: "100%", width: "100%" }}
																	/>
																</div>
																<div className="col-md-6">
																	<label className="form-label">Data final</label>
																	<input
																		type="date"
																		{...register('dataFinal')}
																		className="form-control border-new-light w-100"
																		style={{ minWidth: "100%", width: "100%" }}
																	/>
																</div>
															</div>
														</div>
													</div>

													<div className="col-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Tipo de curso</label>
															<div className="d-flex justify-content-start">
																<div className='me-4'>
																	<label className="form-label d-block text-dark">Híbrido</label>
																	<input
																		type="radio"
																		{...register('tipo', { required: true })}
																		value="misto"
																		className="form-check-input"
																	/>
																</div>
																<div className=''>
																	<label className="form-label d-block text-dark">Online</label>
																	<input
																		type="radio"
																		{...register('tipo', { required: true })}
																		value="online"
																		className="form-check-input"
																	/>
																</div>
															</div>
															{errors.tipo && <span className='text-danger fs-7'>Tipo do curso é obrigatório.</span>}
														</div>
													</div>

												</div>
												<div className="progress col-12 mt-4">
													<div
														className="progress-bar"
														role="progressbar"
														style={{ width: uploadCursoProgress || '0%' }}
														aria-valuenow={uploadCursoProgress || '0'}
														aria-valuemin="0"
														aria-valuemax="100"
													>
														{uploadCursoProgress || '0%'}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{showScrollBottom && (
							<div className="scroll-indicator scroll-indicator-bottom">
								<i className="bi bi-chevron-down"></i>
							</div>
						)}
					</Modal.Body>
					<Modal.Footer className="justify-content-end">
						<div className="d-flex justify-content-end">
							<button
								type="button"
								className="btn me-2"
								onClick={() => {
									setShowModalAddCurso(false);
									setIdTopico("");
								}}
								disabled={isLoading}
							>
								Cancelar
							</button>
							<button type="submit" className="btn btn-primary" disabled={isLoading}>
								{isLoading ? (
									<>
										<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
										Salvando...
									</>
								) : (
									'Salvar'
								)}
							</button>
						</div>
					</Modal.Footer>
				</form>
			</Modal>
		</>
	);
};

export default AddCursoModal;